module.exports = __webpack_public_path__ + "static/hardkoder_dark-ddc79b321b4a96038a4c222dea7ab785.svg";